"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkedEffectsEffectHandler = exports.LinkedEffectsEffectArgs = void 0;
const Duration_1 = require("../../Duration");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class LinkedEffectsEffectArgs {
    constructor(effects, harmful) {
        this.effects = effects;
        this.harmful = harmful;
        this.__type = EffectType_1.EffectType.LinkedEffects;
        this.__typeName = "LinkedEffects";
        this.name = "Linked Effects";
    }
}
exports.LinkedEffectsEffectArgs = LinkedEffectsEffectArgs;
let LinkedEffectsEffectHandler = class LinkedEffectsEffectHandler {
    apply(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        state.meta.childEffectIds = [
            ...container.applyDebuffs({
                sequence,
                attackerId: state.creatorId,
                targetId: state.targetId,
                effects: state.args.effects.filter(effect => effect.harmful)
                    .map(effect => ({
                    duration: Duration_1.Duration.Permanent,
                    supernatural: true,
                    effect,
                }))
            }),
            ...container.applyBuffs({
                sequence,
                creatorId: state.creatorId,
                targetId: state.targetId,
                effects: state.args.effects.filter(effect => !effect.harmful)
                    .map(effect => ({
                    duration: Duration_1.Duration.Permanent,
                    supernatural: true,
                    effect,
                }))
            })
        ];
    }
    remove(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        state.meta.childEffectIds.forEach(effectId => container.cancelEffect(sequence, effectId));
    }
};
LinkedEffectsEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.LinkedEffects)
], LinkedEffectsEffectHandler);
exports.LinkedEffectsEffectHandler = LinkedEffectsEffectHandler;
